module.exports = __webpack_public_path__ + "img/survey-form-untuk-hibah.383976be.png";